import { OpenapiClientPump } from 'foca-openapi';
import { axiosAdapter } from 'foca-openapi/adapters/axios';
import http from './http';

export const pumpApi = new OpenapiClientPump(axiosAdapter(http, (res) => res));
